/* AMM StreamTech AG — site behaviour
 * Replaces jQuery, Bootstrap JS, main.min.js, device.min.js and vanilla-lazyload.
 * No external dependencies. Plain ES5 so it runs without a build step.
 */
(function () {
	'use strict';

	var html      = document.documentElement,
		header    = document.getElementById('top-bar'),
		hero      = document.getElementById('start-screen') || document.getElementById('hero'),
		toggler   = document.getElementById('top-bar__navigation-toggler'),
		nav       = document.getElementById('top-bar__navigation'),
		menuOpen  = false,
		isDesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	function onFrame(fn) {
		var ticking = false;
		return function () {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () { fn(); ticking = false; });
		};
	}

	/* the theme uses a 65px bar once the burger is visible, 90px otherwise */
	function headerHeight() {
		return (toggler && toggler.offsetParent !== null) ? 65 : 90;
	}

	function scrollY() {
		return window.pageYOffset || html.scrollTop || 0;
	}

	/* smooth scroll with a fallback for browsers without behavior:'smooth' */
	function scrollToY(y) {
		if ('scrollBehavior' in html.style) {
			window.scrollTo({ top: y, behavior: 'smooth' });
			return;
		}
		var start = scrollY(), delta = y - start, t0 = null, dur = 600;
		requestAnimationFrame(function step(ts) {
			if (t0 === null) t0 = ts;
			var p = Math.min((ts - t0) / dur, 1),
				e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; /* easeInOutQuad */
			window.scrollTo(0, start + delta * e);
			if (p < 1) requestAnimationFrame(step);
		});
	}

	/* ------------------------------------------------------------------
	 * Sticky header — mirrors the original is-sticky / in / out sequence
	 * ------------------------------------------------------------------ */
	function initStickyHeader() {
		if (!header || !hero) return;
		var sticky = false;

		function update() {
			var trigger = hero.offsetHeight - headerHeight();
			if (scrollY() >= trigger) {
				if (sticky) return;
				sticky = true;
				header.classList.add('is-sticky', 'in');
				once(header, 'animationend', function () { header.classList.remove('in'); });
			} else {
				if (!sticky) return;
				sticky = false;
				header.classList.add('out');
				once(header, 'animationend', function () {
					header.classList.remove('is-sticky', 'out');
				});
			}
		}

		/* Waits for the CSS animation, but never blocks on it: if animations are
		 * suppressed (prefers-reduced-motion, background tab, interrupted state)
		 * animationend never fires and the header would stay stuck. */
		function once(el, ev, fn) {
			var done = false;
			function finish() {
				if (done) return;
				done = true;
				el.removeEventListener(ev, h);
				clearTimeout(timer);
				fn();
			}
			var h = function (e) { if (e.target === el) finish(); };
			var timer = setTimeout(finish, 400); /* longest animation is .3s */
			el.addEventListener(ev, h);
		}

		window.addEventListener('scroll', onFrame(update), { passive: true });
		update();
	}

	/* ------------------------------------------------------------------
	 * Mobile menu
	 * ------------------------------------------------------------------ */
	function setMenu(open) {
		menuOpen = open;
		if (!toggler || !header) return;
		toggler.classList.toggle('is-active', open);
		header.classList.toggle('is-expanded', open);
		html.style.overflow = open ? 'hidden' : '';
	}

	function initMenu() {
		if (!toggler) return;
		toggler.setAttribute('aria-expanded', 'false');
		toggler.setAttribute('aria-controls', 'top-bar__navigation');

		toggler.addEventListener('click', function (e) {
			e.preventDefault();
			setMenu(!menuOpen);
			toggler.setAttribute('aria-expanded', String(menuOpen));
		});

		/* the original closed the mobile menu when the viewport grew past 1199px */
		window.addEventListener('resize', function () {
			if (window.innerWidth > 1199 && menuOpen) {
				setMenu(false);
				toggler.setAttribute('aria-expanded', 'false');
			}
		});
	}

	/* ------------------------------------------------------------------
	 * Anchor links: smooth scroll + close the mobile menu
	 * ------------------------------------------------------------------ */
	function initAnchors() {
		document.addEventListener('click', function (e) {
			var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
			if (!a) return;
			var hash = a.getAttribute('href');
			if (!hash || hash === '#') return;

			var target = document.querySelector(hash) ||
				document.getElementsByName(hash.slice(1))[0];
			if (!target) return;

			e.preventDefault();
			if (menuOpen) {
				setMenu(false);
				toggler.setAttribute('aria-expanded', 'false');
			}
			var top = target.getBoundingClientRect().top + scrollY() - headerHeight();
			scrollToY(Math.max(top, 0));
		});
	}

	/* ------------------------------------------------------------------
	 * Scrollspy — highlights the nav link for the section in view
	 * (replaces Bootstrap's scrollspy)
	 * ------------------------------------------------------------------ */
	function initScrollSpy() {
		if (!nav || header.getAttribute('data-nav-anchor') !== 'true') return;

		var links = [].slice.call(nav.querySelectorAll('a[href^="#"]')),
			targets = links.map(function (a) {
				var h = a.getAttribute('href');
				return (h && h.length > 1)
					? (document.querySelector(h) || document.getElementsByName(h.slice(1))[0] || null)
					: null;
			});

		function update() {
			var pos = scrollY() + headerHeight() + 1, current = -1;
			for (var i = 0; i < targets.length; i++) {
				if (targets[i] && targets[i].getBoundingClientRect().top + scrollY() <= pos) current = i;
			}
			/* pin to the last section once the page is scrolled to the bottom */
			if (scrollY() + window.innerHeight >= html.scrollHeight - 2) {
				for (var j = targets.length - 1; j >= 0; j--) { if (targets[j]) { current = j; break; } }
			}
			links.forEach(function (a, i) { a.classList.toggle('active', i === current); });
		}

		window.addEventListener('scroll', onFrame(update), { passive: true });
		window.addEventListener('resize', onFrame(update));
		update();
	}

	/* ------------------------------------------------------------------
	 * Back-to-top button
	 * ------------------------------------------------------------------ */
	function initBackToTop() {
		var wrap = document.getElementById('btn-to-top-wrap'),
			btn  = document.getElementById('btn-to-top');
		if (!wrap || !btn) return;

		var offset = parseInt(btn.getAttribute('data-visible-offset'), 10) || 800;
		wrap.style.display = 'none';

		btn.addEventListener('click', function (e) { e.preventDefault(); scrollToY(0); });

		var visible = false;
		function update() {
			var should = scrollY() > offset;
			if (should === visible) return;
			visible = should;
			wrap.style.transition = 'opacity .3s';
			if (should) {
				wrap.style.display = '';
				wrap.style.opacity = '0';
				requestAnimationFrame(function () { wrap.style.opacity = '1'; });
			} else {
				wrap.style.opacity = '0';
				setTimeout(function () { if (!visible) wrap.style.display = 'none'; }, 300);
			}
		}
		window.addEventListener('scroll', onFrame(update), { passive: true });
		update();
	}

	/* ------------------------------------------------------------------
	 * Language chooser (currently a single-entry list)
	 * ------------------------------------------------------------------ */
	function initChooseLang() {
		var root = document.querySelector('.js-choose-lang');
		if (!root) return;
		var current = root.querySelector('.current-lang'),
			list    = root.querySelector('.list-wrap');
		if (!current || !list) return;

		list.style.display = 'none';
		current.addEventListener('click', function () {
			var open = list.style.display !== 'none';
			list.style.display = open ? 'none' : 'block';
			root.classList.toggle('is-active', !open);
		});

		document.addEventListener('click', function (e) {
			if (!root.contains(e.target)) {
				list.style.display = 'none';
				root.classList.remove('is-active');
			}
		});
	}

	/* ------------------------------------------------------------------
	 * Lazy background images (replaces vanilla-lazyload)
	 * ------------------------------------------------------------------ */
	function initLazyBackgrounds() {
		var els = [].slice.call(document.querySelectorAll('.lazy[data-bg]'));
		if (!els.length) return;

		function show(el) {
			var bg = el.getAttribute('data-bg');
			if (!bg) return;
			/* markup stores it as  url('img/x.png')  */
			el.style.backgroundImage = bg;
			el.classList.add('is-loaded');
		}

		if (!('IntersectionObserver' in window)) { els.forEach(show); return; }

		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				show(entry.target);
				io.unobserve(entry.target);
			});
		}, { rootMargin: '500px 0px' });

		els.forEach(function (el) { io.observe(el); });
	}

	/* ------------------------------------------------------------------
	 * Tilt on hover (replaces VanillaTilt) — desktop only, as before
	 * ------------------------------------------------------------------ */
	function initTilt() {
		if (!isDesktop || window.matchMedia('(hover: none)').matches) return;
		var els = [].slice.call(document.querySelectorAll('.js-tilt'));
		if (!els.length) return;

		var MAX = 20, PERSPECTIVE = 1000, EASING = 'cubic-bezier(.03,.98,.52,.99)';

		els.forEach(function (el) {
			el.style.transformStyle = 'preserve-3d';

			el.addEventListener('mouseenter', function () {
				el.style.transition = 'transform .3s ' + EASING;
				setTimeout(function () { el.style.transition = ''; }, 300);
			});

			el.addEventListener('mousemove', function (e) {
				var r = el.getBoundingClientRect(),
					px = (e.clientX - r.left) / r.width,
					py = (e.clientY - r.top) / r.height,
					rx = (MAX / 2 - py * MAX).toFixed(2),
					ry = (px * MAX - MAX / 2).toFixed(2);
				el.style.transform = 'perspective(' + PERSPECTIVE + 'px) ' +
					'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale3d(1,1,1)';
			});

			el.addEventListener('mouseleave', function () {
				el.style.transition = 'transform .3s ' + EASING;
				el.style.transform = 'perspective(' + PERSPECTIVE + 'px) rotateX(0deg) rotateY(0deg)';
				setTimeout(function () { el.style.transition = ''; }, 300);
			});
		});
	}

	/* ------------------------------------------------------------------
	 * Footer waves (replaces wavify) — desktop only, as before.
	 * The markup ships <path d=""> so this has to generate the geometry.
	 * ------------------------------------------------------------------ */
	function initWaves() {
		var svgs = [].slice.call(document.querySelectorAll('.js-wave'));
		if (!svgs.length) return;

		var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		svgs.forEach(function (svg) {
			var path = svg.querySelector('path');
			if (!path) return;

			var opts = { height: 100, amplitude: 90, speed: 0.15, bones: 3, color: 'rgba(255,255,255,1)' };
			try {
				var raw = svg.getAttribute('data-wave');
				if (raw) { var o = JSON.parse(raw); for (var k in o) opts[k] = o[k]; }
			} catch (err) { /* keep defaults */ }

			path.setAttribute('fill', opts.color);

			function points(factor) {
				var w = svg.clientWidth || svg.parentNode.clientWidth || 1200, pts = [];
				for (var i = 0; i <= opts.bones; i++) {
					var seed = (factor + (i + i % opts.bones)) * opts.speed * 100,
						sh = Math.sin(seed / 100) * opts.amplitude;
					pts.push({ x: (i / opts.bones) * w, y: Math.sin(seed / 100) * sh + opts.height });
				}
				return pts;
			}

			function draw(pts) {
				var w = svg.clientWidth || svg.parentNode.clientWidth || 1200,
					h = svg.clientHeight || 200,
					d = 'M ' + pts[0].x + ' ' + pts[0].y;
				for (var i = 1; i < pts.length; i++) {
					var p = pts[i], prev = pts[i - 1], cx = (prev.x + p.x) / 2;
					d += ' C ' + cx + ' ' + prev.y + ' ' + cx + ' ' + p.y + ' ' + p.x + ' ' + p.y;
				}
				return d + ' L ' + w + ' ' + h + ' L 0 ' + h + ' Z';
			}

			if (reduce || !isDesktop) { path.setAttribute('d', draw(points(0))); return; }

			/* Advance by PI per elapsed second, matching the original wavify
			 * timing. Driving this per-frame instead would run ~19x too fast.
			 * Elapsed time comes from the wall clock rather than the rAF
			 * timestamp, which can be frozen or coarsened by the browser. */
			var start = Date.now();
			requestAnimationFrame(function loop() {
				path.setAttribute('d', draw(points(((Date.now() - start) / 1000) * Math.PI)));
				requestAnimationFrame(loop);
			});
		});
	}

	/* ------------------------------------------------------------------
	 * Background parallax (replaces jarallax) — desktop only, as before.
	 * Every .jarallax element already carries an inline background-image,
	 * so with this disabled it simply renders static.
	 * ------------------------------------------------------------------ */
	function initParallax() {
		if (!isDesktop || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
		var els = [].slice.call(document.querySelectorAll('.jarallax'));
		if (!els.length) return;

		els.forEach(function (el) {
			var pos = el.getAttribute('data-img-position') || '50% 50%',
				parts = pos.split(/\s+/),
				xPos = parts[0] || '50%',
				speed = parseFloat(el.getAttribute('data-speed'));
			if (isNaN(speed)) speed = 0.5;
			var yPos = parts[1] || '50%';

			/* style.min.css already sets .jarallax{background-attachment:fixed},
			 * so there is no need to repeat it inline. Note this differs from
			 * real jarallax, which removed the element background entirely and
			 * animated an injected .jarallax-img instead. */
			el.style.backgroundPosition = xPos + ' ' + yPos;

			function update() {
				var r = el.getBoundingClientRect();
				if (r.bottom < 0 || r.top > window.innerHeight) return;
				var shift = (r.top - window.innerHeight / 2) * (1 - speed) * -0.15;
				el.style.backgroundPosition = xPos + ' calc(' + yPos + ' + ' + shift.toFixed(1) + 'px)';
			}
			window.addEventListener('scroll', onFrame(update), { passive: true });
			update();
		});
	}

	/* ------------------------------------------------------------------
	 * Copyright year
	 * ------------------------------------------------------------------ */
	function initYear() {
		var y = String(new Date().getFullYear());
		[].forEach.call(document.querySelectorAll('.js-current-year'), function (el) {
			el.textContent = y;
		});
	}

	function init() {
		html.className = html.className.replace('no-js', 'js');
		html.classList.add(isDesktop ? 'desktop' : 'mobile');
		initStickyHeader();
		initMenu();
		initAnchors();
		initScrollSpy();
		initBackToTop();
		initChooseLang();
		initLazyBackgrounds();
		initTilt();
		initWaves();
		initParallax();
		initYear();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
